import { IOBuffer } from 'iobuffer';
import { createStepArray } from 'ml-spectra-processing';

export async function setFIDSpectrumData(file, spectra) {
  let td = parseInt(spectra.meta.TD[0], 10);
  let ioBuffer = new IOBuffer(await file.arrayBuffer());

  if (td * spectra.meta.nbSubSpectra * 4 > ioBuffer.length) {
    throw new RangeError(
      `td: ${td} and nbSubSpectra: ${nbSubSpectra} exceed the buffer size`,
    );
  }

  let SW_H = Number(spectra.meta.SW_h[0]);

  let SF = Number(spectra.meta.SFO1[0]);

  spectra.meta.DATATYPE = 'NMR FID';

  let DW = 1 / (2 * SW_H);
  let AQ = td * DW;

  let endian = parseInt(spectra.meta.BYTORDA, 10);
  endian = endian ? 0 : 1;

  if (endian) {
    ioBuffer.setLittleEndian();
  } else {
    ioBuffer.setBigEndian();
  }

  let nbSubSpectra = spectra.meta.nbSubSpectra
    ? spectra.meta.nbSubSpectra / 2
    : 1;

  spectra.spectra = new Array(nbSubSpectra);

  const stopReading = td / 2;
  for (let j = 0; j < nbSubSpectra; j++) {
    let toSave = {
      dataType: 'NMR FID',
      dataTable: '(X++(R..R))',
      nbPoints: td,
      firstX: 0,
      lastX: AQ,
      nucleus: spectra.meta.NUC1,
      xUnit: 'Sec',
      yUnit: 'Arbitrary',
      data: {
        x: createStepArray({ length: td, step: DW }),
        re: new Float64Array(td),
        im: new Float64Array(td),
      },
      isXYdata: true,
      observeFrequency: SF,
      title: spectra.meta.TITLE,
      deltaX: DW,
    };
    spectra.spectra[j] = toSave;

    for (let i = 0; i < stopReading; i++) {
      spectra.spectra[j].data.re[i] = ioBuffer.readInt32();
      spectra.spectra[j].data.im[i] = ioBuffer.readInt32();
    }
  }
}
